import { render, staticRenderFns } from "./ContactUsPopup.vue?vue&type=template&id=7386cd74&scoped=true&"
import script from "./ContactUsPopup.vue?vue&type=script&lang=ts&"
export * from "./ContactUsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ContactUsPopup.vue?vue&type=style&index=0&id=7386cd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7386cd74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7386cd74')) {
      api.createRecord('7386cd74', component.options)
    } else {
      api.reload('7386cd74', component.options)
    }
    module.hot.accept("./ContactUsPopup.vue?vue&type=template&id=7386cd74&scoped=true&", function () {
      api.rerender('7386cd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/ContactUsPopup.vue"
export default component.exports